import _ from 'lodash';

export default {
    computed: {
        ShowPrices() {
            return !(_.find(this.$store.state.auth.roles, i => _.toUpper(i) === "HIDEPRICES"));
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/ShowPrices.js